import { useEffect, useState } from 'react';
import { useGetFormMetadataQuery } from '../../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/FormMetadataRpc.hooks';
import type { EditorVersion, EditorVersionResolver } from './types';

export function useResolveEditorVersion({
  formId,
  portalId,
  env,
  editorVersion,
  resolveEditorVersion,
}: {
  formId: string;
  portalId: string;
  env: string;
  editorVersion?: EditorVersion;
  resolveEditorVersion?: EditorVersionResolver;
}): EditorVersion | null {
  const skipQuery = editorVersion != null || resolveEditorVersion != null;
  const { data: formMetadata } = useGetFormMetadataQuery({
    variables: { formGuid: formId },
    skip: skipQuery,
  });

  const [customResolvedVersion, setCustomResolvedVersion] =
    useState<EditorVersion | null>(null);

  useEffect(() => {
    if (!resolveEditorVersion || editorVersion != null) {
      return;
    }
    let cancelled = false;
    resolveEditorVersion(portalId, formId, env)
      .then((version) => {
        if (!cancelled) setCustomResolvedVersion(version);
      })
      .catch(() => {
        if (!cancelled) setCustomResolvedVersion(1);
      });
    return () => {
      cancelled = true;
    };
  }, [resolveEditorVersion, editorVersion, portalId, formId, env]);

  return (
    editorVersion ??
    customResolvedVersion ??
    (formMetadata ? (formMetadata.formCreatedByEditorV2 ? 2 : 1) : null)
  );
}
